const isBlank = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

export const validationRules = {
  required:
    (message = "Kolom ini wajib diisi.") =>
    (value) =>
      (isBlank(value) ? message : ""),
  email:
    (message = "Format email belum valid.") =>
    (value) =>
      (!isBlank(value) && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim()) ? message : ""),
  phone:
    (message = "Gunakan 8–15 digit angka untuk nomor telepon.") =>
    (value) =>
      (!isBlank(value) && !/^\d{8,15}$/.test(String(value).replace(/[\s()+-]/g, "")) ? message : ""),
  minLength:
    (minimum, message = `Minimal ${minimum} karakter.`) =>
    (value) =>
      (!isBlank(value) && String(value).length < minimum ? message : ""),
  maxLength:
    (maximum, message = `Maksimal ${maximum} karakter.`) =>
    (value) =>
      (!isBlank(value) && String(value).length > maximum ? message : ""),
  number:
    (message = "Kolom ini harus berupa angka.") =>
    (value) =>
      (!isBlank(value) && !Number.isFinite(Number(value)) ? message : ""),
  min:
    (minimum, message = `Nilai minimal ${minimum}.`) =>
    (value) =>
      (!isBlank(value) && Number(value) < minimum ? message : ""),
  max:
    (maximum, message = `Nilai maksimal ${maximum}.`) =>
    (value) =>
      (!isBlank(value) && Number(value) > maximum ? message : ""),
  greaterThan:
    (minimum = 0, message = "Nilai harus lebih dari 0.") =>
    (value) =>
      (!isBlank(value) && Number(value) <= minimum ? message : ""),
  integer:
    (message = "Nilai harus berupa bilangan bulat.") =>
    (value) =>
      (!isBlank(value) && !Number.isInteger(Number(value)) ? message : ""),
  oneOf:
    (values, message = "Pilihan tidak tersedia.") =>
    (value) =>
      (!isBlank(value) && !values.includes(value) ? message : ""),
  pattern:
    (pattern, message) =>
    (value) =>
      (!isBlank(value) && !pattern.test(String(value)) ? message : ""),
  sameAs:
    (field, message = "Nilai tidak sama.") =>
    (value, values) =>
      (!isBlank(value) && value !== values?.[field] ? message : ""),
  requiredWhen:
    (predicate, message = "Kolom ini wajib diisi.") =>
    (value, values) =>
      (predicate(values) && isBlank(value) ? message : ""),
  custom:
    (validator) =>
    (value, values) =>
      validator(value, values) || "",
};

const normalizeRules = (rules) => (Array.isArray(rules) ? rules : [rules]).filter(Boolean);

export const validateFieldValue = (value, rules, values = {}) => {
  for (const rule of normalizeRules(rules)) {
    const message = typeof rule === "function" ? rule(value, values) : "";
    if (message) return message;
  }

  return "";
};

export const validateFormValues = (values = {}, schema = {}) =>
  Object.entries(schema).reduce((errors, [field, rules]) => {
    const message = validateFieldValue(values?.[field], rules, values);
    if (message) errors[field] = message;
    return errors;
  }, {});

export const hasValidationErrors = (errors = {}) => Object.keys(errors).length > 0;

export const focusFirstInvalidField = (errors = {}, root) => {
  const firstField = Object.keys(errors)[0];
  if (!firstField || typeof document === "undefined") return;

  const scope = root?.current || root || document;
  const escaped = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(firstField) : firstField.replace(/["\\]/g, "");
  const target = scope.querySelector?.(`[name="${escaped}"], [data-validation-field="${escaped}"]`);
  target?.scrollIntoView?.({ behavior: "smooth", block: "center" });
  window.setTimeout(() => target?.focus?.(), 180);
};

export const fieldErrorId = (formId, field) => `${formId}-${String(field).replace(/[^a-zA-Z0-9_-]/g, "-")}-feedback`;

export const getApiFieldErrors = (error) => {
  const payload = error?.response?.data;
  const source = payload?.data?.errors || payload?.errors;
  if (!source || typeof source !== "object") return {};

  return Object.entries(source).reduce((errors, [field, messages]) => {
    const value = Array.isArray(messages) ? messages[0] : messages;
    if (value) errors[field] = String(value);
    return errors;
  }, {});
};

